import * as angular from 'angular';
import controller from './scheduledCheckLists.controller';
import template from './scheduledCheckLists.tpl.html';

export default angular.module('aps.directive.scheduledCheckLists', [controller])
  .directive('apsScheduledCheckLists', scheduledCheckListsDef)
  .name;

function scheduledCheckListsDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'ScheduledCheckListsCtrl',
    controllerAs: 'vm',
    scope: {
      checkListView: '@',
      checkListViewAll: '='
    },
    bindToController: true,
    link: function ($scope: any) {
      $scope.$watch('vm.checkListViewAll', function (viewAll) {
        $scope.vm.viewAllChanged(viewAll);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checkLists/scheduledCheckLists.directive.ts